import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Home from './pages/Home'; 
import './App.css';
import './assets/css/style.css'; 
import './assets/css/common.css';  
import './assets/css/auth.css';  
import Topbar from './component/Topbar';
import Sidebar from './component/Sidebar';
import Login from './pages/Auth/Login';
import AddHostelOwner from './pages/AddHostelOwner'; 
import Register from './pages/Auth/Register';
import BusinessInfo from './pages/Auth/BusinessInfo';
import FeaturesOpt from './pages/Auth/FeaturesOpt';
import CreateInvoice from './pages/Invoice/CreateInvoice';
import AllInvoice from './pages/Invoice/AllInvoice';
import CreditNote from './pages/Invoice/CreditNote';
import CreateQuotation from './pages/Quotation/CreateQuotation';
import AllQuotation from './pages/Quotation/AllQuotation';
import QuotationConvert from './pages/Quotation/QuotationConvert';
import CreatePurchaseOrder from './pages/PurshaseOrder/CreatePurchaseOrder';
import SupplierBills from './pages/PurshaseOrder/SupplierBills';
import PurchaseOrderTracker from './pages/Quotation/PurchaseToGRN';
import AddProduct from './pages/Product/AddProduct';
import AllProductService from './pages/Product/AllProductService';
import ProductCatelog from './pages/Product/ProductCatelog';
import CurrentStock from './pages/Inventory/CurrentStock';
import StockAdjust from './pages/Inventory/StockAdjust';
import LowStockAlert from './pages/Inventory/LowStockAlert';
import AddExpense from './pages/IncomeExpense/AddExpense';
import ExpenseCategory from './pages/IncomeExpense/ExpenseCategory';
import ExpenseReport from './pages/IncomeExpense/ExpenseReport';
import AllCustomer from './pages/Customer/AllCustomer';
import EditInvoice from './pages/Invoice/EditInvoice';
import InvoiceOne from './pages/InvoiceUI/InvoiceOne';
import InvoiceTwo from './pages/InvoiceUI/InvoiceTwo';
import InvoiceThree from './pages/InvoiceUI/InvoiceThree';
import Invoice from './pages/InvoiceUI/Invoice';
import PrintInvoice from './pages/Invoice/PrintInvoice';
import EditQuotation from './pages/Quotation/EditQuotation';
import EditProduct from './pages/Product/EditProduct';
import EditExpense from './pages/IncomeExpense/EditExpense';
import AllExpenses from './pages/IncomeExpense/AllExpenses';
import MyAccount from './pages/Setting/MyAccount';
import InvoiceFour from './pages/InvoiceUI/InvoiceFour';
import InvoiceFive from './pages/InvoiceUI/InvoiceFive';
import InvoiceSix from './pages/InvoiceUI/InvoiceSix';
import InvoiceSeven from './pages/InvoiceUI/InvoiceSeven';


function App() {
  return (
    <Router>
      
  


      <Routes>
        <Route path="/" element={<Login />} />   
        <Route path="/register" element={<Register />} />   
        <Route path="/register-info" element={<BusinessInfo />} />   
        <Route path="/opt-features" element={<FeaturesOpt />} />  


        <Route path="/invoice-create" element={<CreateInvoice />} />   
        <Route path="/invoice-edit/:id" element={<EditInvoice />} />   
        <Route path="/invoices" element={<AllInvoice />} />   
        <Route path="/invoice-credit-notes" element={<CreditNote />} />   


        <Route path="/invoice-one" element={<InvoiceOne />} />   
        <Route path="/invoice-two" element={<InvoiceTwo />} />   
        <Route path="/invoice-three" element={<InvoiceThree />} /> 
        <Route path="/invoice-four" element={<InvoiceFour />} /> 
        <Route path="/invoice-five" element={<InvoiceFive />} /> 
        <Route path="/invoice-six" element={<InvoiceSix />} /> 
        <Route path="/invoice-seven" element={<InvoiceSeven />} /> 


        <Route path="/settings-invoice-template" element={<Invoice />} />   
        <Route path="/invoice/:id" element={<PrintInvoice />} />   





        <Route path="/estimate-create" element={<CreateQuotation />} />   
        <Route path="/estimates" element={<AllQuotation />} />   
        <Route path="/estimate-convert" element={<QuotationConvert />} /> 
        <Route path="/quotation-edit/:encodedId" element={<EditQuotation />} /> 


        <Route path="/purchase-create" element={<CreatePurchaseOrder />} />   
        <Route path="/supplier-bills" element={<SupplierBills />} />   
        <Route path="/po-grn" element={<PurchaseOrderTracker />} /> 


        <Route path="/product-add" element={<AddProduct />} />   
        <Route path="/edit-product/:uuid" element={<EditProduct />} />   
        <Route path="/products" element={<AllProductService />} />   
        <Route path="/product-catalog" element={<ProductCatelog />} />  


        <Route path="/inventory-stock" element={<CurrentStock />} />   
        <Route path="/inventory-adjust" element={<StockAdjust />} />   
        <Route path="/inventory-alerts" element={<LowStockAlert />} />   


        <Route path="/expense-add" element={<AddExpense />} />   
        <Route path="/expense-update/:uuid" element={<EditExpense />} />   
        <Route path="/expense-categories" element={<ExpenseCategory />} />   
        <Route path="/expense-report" element={<ExpenseReport />} />
        <Route path="/expenses" element={<AllExpenses />} />


        <Route path="/customers" element={<AllCustomer />} />
        <Route path="/profile" element={<MyAccount />} />





        <Route path="/dashboard" element={<Home />} />   
        <Route path="/create-hostel-owner" element={<AddHostelOwner />} />     
 
 

 



      </Routes>
  
    </Router>
  );
}

export default App;
